import React from 'react'
import { useSelector } from 'react-redux'
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from '../../../../../components/mui/Core/index'
import {
  getCurrencyFormattedValue,
  getDateFormattedValue,
  getTimeFormattedValue,
} from '../../../../../utils/string-utils'
import Constants from '../../../../../constants/en.json'
import CopyContentButton from '../../../../../components/genericcomponents/CopyContentButton/copy-content-button'

function ShippingDetailsCard() {
  const shipments = useSelector((state) => state.orderList.shipments)
  const orderDetails = useSelector((state) => state.orderList.orderDetails)
  const shipPO = orderDetails?.shipPO || Constants.orderAllocations.NONE
  const shipEmailAddress = orderDetails?.shipEmailAddress
  const contactEmail = `${Constants.orders.order_details.CONTACT_EMAIL}`
  const cardStyle = { height: '100%' }
  const headerStyle = { py: 3 }
  const bodyStyle = { py: 2 }
  const smallTopMargin = { mt: 1.5 }
  const mediumTopMargin = { mt: 2 }
  const shipEmailStyle = { wordBreak: 'break-word' }

  return (
    <Card variant='outlined' sx={cardStyle}>
      <CardContent sx={headerStyle}>
        <Typography variant='h6'>{Constants.orders.order_details.SHIPPING_DETAILS}</Typography>
      </CardContent>
      <Divider />
      <CardContent sx={bodyStyle}>
        <Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>{Constants.orders.order_details.SHIP_TO_NAME}</Typography>
              <Typography variant='body1'>{orderDetails?.shipToName}</Typography>
              <Typography variant='body1'>{orderDetails?.shipToCustNum}</Typography>
            </Grid>

            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>{Constants.orders.order_details.PO_NUMBER}</Typography>
              <Typography variant='body1'>{shipPO}</Typography>
            </Grid>

            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>{Constants.orders.order_details.TOTAL_SHIPMENTS}</Typography>
              <Typography variant='body1'>{shipments.length}</Typography>
            </Grid>

            <Grid size={{ xs: 3 }}>
              <CopyContentButton content={shipEmailAddress} headerName={contactEmail} />
              <Typography variant='body1' sx={shipEmailStyle}>
                {shipEmailAddress || `${Constants.orders.order_details.NONE}`}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={mediumTopMargin}>
            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>{Constants.orders.order_details.SHIP_TO_ADDRESS}</Typography>
              {orderDetails?.shipAddr1 && (
                <Typography variant='body1'>{orderDetails.shipAddr1}</Typography>
              )}
              {orderDetails?.shipAddr2 && (
                <Typography variant='body1'>{orderDetails.shipAddr2}</Typography>
              )}
              {orderDetails?.shipAddr3 && (
                <Typography variant='body1'>{orderDetails.shipAddr3}</Typography>
              )}
              <Typography variant='body1'>
                {orderDetails?.shipCity}, {orderDetails?.shipState} {orderDetails?.shipCountry}{' '}
                {orderDetails?.shipZip}
              </Typography>
            </Grid>

            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>{Constants.orders.order_details.ORDER_VALUE}</Typography>
              <Typography variant='body1'>
                {orderDetails?.dmsDollarValue &&
                  getCurrencyFormattedValue(orderDetails?.dmsDollarValue)}
              </Typography>
            </Grid>

            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>{Constants.orders.order_details.CREATED_ON}</Typography>
              <Typography variant='body1'>
                {getDateFormattedValue(orderDetails?.createdOn)},
              </Typography>
              <Typography variant='body1'>
                {getTimeFormattedValue(orderDetails?.createdOn)}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={mediumTopMargin}>
            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>{Constants.orders.order_details.PRICING_TERMS}</Typography>
              <Typography variant='body1'>{orderDetails?.pricingTerm}</Typography>
            </Grid>

            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>
                {Constants.orders.order_details.PREPAID_OR_COLLECT}
              </Typography>
              <Typography variant='body1'>{orderDetails?.prepaidOrCollect}</Typography>
            </Grid>

            <Grid size={{ xs: 3 }} sx={smallTopMargin}>
              <Typography variant='h6'>{Constants.orders.order_details.ORDER_TYPE}</Typography>
              <Typography variant='body1'>{orderDetails?.orderType}</Typography>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  )
}

export default ShippingDetailsCard
